import { jsx as _jsx } from "react/jsx-runtime";
import { MuiMarkdown_V2 } from "../../../../Shared/components/MuiMarkdown/MuiMarkdown_V2";
import { useMarkdownModule } from "./useMarkdownModule";
export const MarkdownModule = ({ sequenceNumber }) => {
    const { MarkdownText } = useMarkdownModule(sequenceNumber);
    return _jsx(MuiMarkdown_V2, { children: MarkdownText });
};
